import React from 'react'
import PropTypes from 'prop-types'
import { ratioOptions } from '@scentregroup/ui/tools/cloudinary/image'
import ResponsiveImage from '../responsive-image'
import ResponsiveVideo from '../responsive-video'

const ResponsiveAsset = ({
  angleOrigin,
  className,
  desktopImageUrl,
  mobileImageUrl,
  videoUrl,
  mobileRatio,
  desktopRatio,
  numberOfItems,
  alt,
  lazyLoad,
  bgSize,
  onLoad,
  onError,
  dataTestId,
}) => {
  const commonProps = {
    className,
    bgSize,
    angleOrigin,
    mobileRatio,
    desktopRatio,
    numberOfItems,
    alt,
    lazyLoad,
    onLoad,
    onError,
    dataTestId,
  }
  if (videoUrl) {
    return (
      <ResponsiveVideo
        videoUrl={videoUrl}
        {...commonProps}
        data-test-id={dataTestId}
      />
    )
  }
  return (
    <ResponsiveImage
      desktopImageUrl={desktopImageUrl}
      mobileImageUrl={mobileImageUrl}
      {...commonProps}
      data-test-id={dataTestId}
    />
  )
}

ResponsiveAsset.defaultProps = {
  alt: '',
  lazyLoad: true,
}

ResponsiveAsset.propTypes = {
  angleOrigin: PropTypes.oneOf([
    'bottom-left',
    'top-left',
    'top-right',
    'bottom-right',
  ]),
  className: PropTypes.string,
  heroImageSet: PropTypes.object,
  loading: PropTypes.bool,
  desktopImageUrl: PropTypes.string,
  mobileImageUrl: PropTypes.string,
  videoUrl: PropTypes.string,
  mobileRatio: PropTypes.oneOf(ratioOptions),
  desktopRatio: PropTypes.oneOf(ratioOptions),
  numberOfItems: PropTypes.number,
  alt: PropTypes.string,
  lazyLoad: PropTypes.bool,
  bgSize: PropTypes.oneOf(['cover', 'contain']),
  onLoad: PropTypes.func,
  onError: PropTypes.func,
  dataTestId: PropTypes.string,
}

export default ResponsiveAsset
